<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12">
          <v-row class="pb-3 mb-3" style="border-bottom: 1px solid #EDEDED">
            <v-col class="col-12">
              <h2 class="mx-2 text-center text-md-left" style="color: var(--v-primary-base)">
                <v-icon size="32" color="primary" class="mr-2">date_range</v-icon>Agenda
              </h2>
            </v-col>
          </v-row>
          <v-row class="justify-center align-center flex-column fill-height" v-if="isLoading">
            <p>Carregando...</p>
            <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
          </v-row>
          <v-row v-if="isConsultation && !isLoading">
            <v-col class="col-12">
              <div class="schedule pa-3">
                <div>
                  <p class="subtitle-1">
                    <v-icon x-large color="gray" class="mx-2">sentiment_very_satisfied</v-icon>Aqui estão seus compromissos, caso queira agendar mais e só clicar no botão agendar.
                  </p>
                </div>
                <v-btn
                  @click="()=>{this.$router.push({name: 'BuscaPaciente'})}"
                  large
                  color="success"
                >AGENDAR</v-btn>
              </div>
            </v-col>
            <v-col class="col-12 col-md-4" v-for="(item, index) in consultation" :key="index">
              <v-divider></v-divider>
              <router-link
                tag="div"
                style="cursor: pointer;"
                class="my-list"
                :to="{name: 'DetalheConsultaPaciente', params: {id: item.id}}"
              >
                <p class="ma-0">{{item.psychologist.name}}</p>
                <span class="date ma-2 align-end d-flex">
                  <v-icon color="primary">date_range</v-icon>
                  <p class="mb-0 ml-2">{{ item.date | formatDate }}</p>
                </span>
                <span class="time ma-2 align-end d-flex">
                  <v-icon color="primary">access_time</v-icon>
                  <!-- <p class="mb-0 ml-2">{{item.time}}</p> -->
                  <p class="mb-0 ml-2">{{ item.time | formatDateTZ(item.date) }}</p>
                </span>
              </router-link>
            </v-col>
            <v-pagination v-model="page" :length="lengthPage"></v-pagination>
          </v-row>
          <v-row class="fill-height justify-center" v-if="!isConsultation && !isLoading">
            <v-col class="col-6">
              <div class="no-schedule pa-3">
                <v-icon
                  x-large
                  color="gray"
                  style="font-size: 80px; padding-bottom:10px"
                >sentiment_very_dissatisfied</v-icon>
                <p
                  class="subtitle-1"
                  style="color: #6F6F6F; font-weight: bold"
                >Você não tem compromissos futuros.</p>
                <v-btn
                  @click="()=>{this.$router.push({name: 'BuscaPaciente'})}"
                  large
                  color="success"
                >AGENDAR</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';

export default {
  data() {
    return {
      cod: '',
      consultation: [],
      isConsultation: Boolean,
      isLoading: false,
      page: 1,
      lengthPage: 1,
    };
  },
  async created() {
    await this.getCod();
    await this.allConsultation();
  },
  watch: {
    page() {
      this.allConsultation();
    },
  },
  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    async allConsultation() {
      this.isLoading = true;
      try {
        const { data, status } = await http.get(
          `/patients/${this.cod}/appointments/`,
          {
            params: {
              page: this.page,
            },
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );
        if (status == 200) {
          if (data.results.length != 0) {
            this.lengthPage = Math.ceil(data.count / 10);
            this.consultation = data.results;
            this.isConsultation = true;
          } else {
            this.isConsultation = false;
          }
        }
      } catch (error) {
        console.log(error.response.data.detail);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.my-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0;
}
.my-list p {
  flex: 1;
}
.no-schedule,
.schedule {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #02a55333;
  border-radius: 20px;
  border: 1px dashed #02a554;
}
.schedule {
  flex-direction: row;
}
.schedule p {
  display: flex;
  align-items: center;
  margin: 0 15px;
  color: rgb(111, 111, 111);
  font-weight: bold;
}
</style>
